module.exports = __webpack_public_path__ + "img/c.5700480b.png";